export default () => ({
	configuration: JSON.parse(localStorage.getItem('app-configuration-new')) || {},
	returningPartReasons: []
})
